module.exports = __webpack_public_path__ + "img/649d775059dd26446a7176b9ca524592.649d7750.png";